<template>
  <el-breadcrumb separator-class="el-icon-arrow-right" class="def-w layout-breadcrumb f-start-c">
    <el-breadcrumb-item v-for="(menu, index) in breadcrumbList" :key="menu.id + '_' + index" :to="getRoute(menu)">
      <div v-if="menu.isQuery" class="search-item">
        {{ menu.name }}
        <i class="el-icon-close" />
      </div>
      <template v-else>
        {{ menu.name }}
      </template>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
import { mapGetters } from "vuex";
import { NAV_MENU_CODE } from "@/utils/constant";

export default {
  name: "LayoutBreadcrumb",
  components: {},
  props: {
  },
  data() {
    return {};
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["activeMenuTree", "allMenusList", "curDetailTitle"]),
    breadcrumbList() {
      const homeMenu = this.allMenusList.find(m => m.code === NAV_MENU_CODE.HOME)
      if (this.$route.path === "/searchResult") {
        return [homeMenu, { name: "全站搜索", id: Math.random(), path: this.$route.path, query: this.$route.query, params: this.$route.params }]
      }
      const breadcrumbArr = [homeMenu, ...this.activeMenuTree]
      this.$route.path.includes("/detail") && breadcrumbArr.push({ name: this.curDetailTitle, id: Math.random(), path: this.$route.path, query: this.$route.query, params: this.$route.params })
      this.$route.query.title && breadcrumbArr.push({ name: this.$route.query.title, id: Math.random(), isQuery: true })
      return breadcrumbArr
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    isLastItem(menu) {
      const index = this.breadcrumbList.findIndex(b => b.id === menu.id)
      return index === this.breadcrumbList.length - 1 || index === -1
    },
    getRoute(menu) {
      if (menu.code === "xmgg") {
        return null;
      }
      return this.isLastItem(menu) && !menu.isQuery ? null : { path: menu.path, params: menu.params, query: { ...menu.query, t: Date.now() }}
    }
  }
};
</script>

<style scoped lang="scss">
.layout-breadcrumb{
  height: 50px;
  ::v-deep{
    .el-breadcrumb__item{
      float: none;
      white-space: nowrap;
      display: flex;
      align-items: center;
    }
    .el-breadcrumb__inner{
      line-height: 1.5;
      display: block;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .search-item{
    background-color: #F5F5F5;
    cursor: pointer;
    color: #666;
    padding-left: 10px;
    padding-right: 25px;
    position: relative;
    border: 1px solid #F5F5F5;
    .el-icon-close{
      font-size: 12px;
      line-height: 1;
      position: absolute;
      right: 6px;
      top: 50%;
      transform: translateY(-5px);
      color: #666;
    }
    &:hover{
      border: 1px solid $--color-primary;
      .el-icon-close{
        color: $--color-primary;
      }
    }
  }
}
</style>
